var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2863_33753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6187 8.96267C39.6457 9.35327 39.6457 9.74387 39.6457 10.1381C39.6457 22.1495 30.5017 36.0023 13.7815 36.0023V35.9951C8.84226 36.0023 4.00566 34.5875 -0.152344 31.9199C0.565856 32.0063 1.28766 32.0495 2.01126 32.0513C6.10446 32.0549 10.0807 30.6815 13.3009 28.1525C9.41106 28.0787 6.00006 25.5425 4.80846 21.8399C6.17106 22.1027 7.57506 22.0487 8.91246 21.6833C4.67166 20.8265 1.62066 17.1005 1.62066 12.7733V12.6581C2.88426 13.3619 4.29906 13.7525 5.74626 13.7957C1.75206 11.1263 0.520856 5.81267 2.93286 1.65827C7.54806 7.33727 14.3575 10.7897 21.6673 11.1551C20.9347 7.99787 21.9355 4.68947 24.2971 2.47007C27.9583 -0.971528 33.7165 -0.795128 37.1581 2.86427C39.1939 2.46287 41.1451 1.71587 42.9307 0.657472C42.2521 2.76167 40.8319 4.54907 38.9347 5.68487C40.7365 5.47247 42.4969 4.99007 44.1547 4.25387C42.9343 6.08267 41.3971 7.67567 39.6187 8.96267Z",
    fill: "#1D9BF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2863_33753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fb471986b47fcb45ffb4741a882b8a90.svg";
export { ForwardRef as ReactComponent };